import { Injectable, Inject } from "@angular/core";
import { HttpClient, HttpBackend } from "@angular/common/http";
import { IConfiguration } from "../model/configuration.model";

@Injectable()
export class ConfigurationService {
  private readonly http: HttpClient;
  private configData?: IConfiguration;
  private configDataPromise?: Promise<void>;

  constructor(httpHandler: HttpBackend, @Inject("BASE_URL") private readonly baseUrl: string) {
    // using a custom handler allows us to bypass the Auth Interceptor for this call.
    // Auth Interceptor again depends on config, on SharedServices and a big-ass dependency-tree
    // which we don't want to trigger simply to config to bootstrap our services (and landing page)!
    this.http = new HttpClient(httpHandler);
  }

  async loadConfiguration(): Promise<void> {
    if (this.configData) {
      return;
    }

    if (!this.configDataPromise) {
      this.configDataPromise = this.loadConfigurationImpl();
    }
    await this.configDataPromise;
    this.configDataPromise = null;
  }

  private async loadConfigurationImpl(): Promise<void> {
    const result = await this.http.get<IConfiguration>(`${this.baseUrl}api/ConfigSettings`).toPromise();
    this.configData = result;
  }

  get config(): IConfiguration {
    return this.configData;
  }

  get environment() : "sod" | "stage" | "prod" {
    if(this.baseUrl.startsWith("https://superofficeforoutlook.superoffice.com"))
      return "prod";
    if(this.baseUrl.startsWith("https://superofficeforoutlook-stage.superoffice.com"))
      return "stage"
    if(this.baseUrl.startsWith("https://superofficeforoutlook-sod.superoffice.com"))
      return "sod";
    if(this.baseUrl.startsWith("https://localhost") || this.baseUrl.startsWith("http://localhost"))
      return "sod";

    throw new Error("Unable to determine runtime environment");
  }

  get getBaseUrl() {
    return this.baseUrl;
  }
}
